import { Link2, Mail, X } from 'lucide-react';

import { inviteSubtitle } from './invite-form-model';

interface InviteDrawerHeaderProps {
  /** True when the invite will bind an existing imported row. */
  isLink: boolean;
  onClose: () => void;
}

/** The drawer's title bar, which reads differently when the invite links an
 *  existing record. */
export default function InviteDrawerHeader({ isLink, onClose }: InviteDrawerHeaderProps) {
  return (
    <div
      className={`px-6 pt-5 pb-3.5 border-b border-stone-200 dark:border-stone-800 flex items-start gap-3 ${
        isLink ? 'bg-[#FAECD8] dark:bg-[#33260F]' : ''
      }`}
    >
      <div
        className={`w-9 h-9 rounded-lg flex items-center justify-center flex-none ${
          isLink
            ? 'bg-white text-[#BA7517] dark:bg-[#1a1f1c] dark:text-[#F0C97D]'
            : 'bg-moss-50 text-moss-700 dark:bg-[#0d2b1c] dark:text-moss-200'
        }`}
      >
        {isLink ? <Link2 size={18} /> : <Mail size={18} />}
      </div>
      <div className="flex-1">
        <h2
          id="invite-title"
          className="m-0 text-lg font-bold text-bark-900 dark:text-[#e8ece9] leading-none"
        >
          {isLink ? 'Link & invite' : 'Invite user'}
        </h2>
        <div className="text-[12px] text-stone-600 dark:text-stone-400 mt-1.5 leading-snug">
          {inviteSubtitle(isLink)}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close invite drawer"
        className="w-7 h-7 rounded-md text-stone-500 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-[#242d28] inline-flex items-center justify-center"
      >
        <X size={16} />
      </button>
    </div>
  );
}
